import { QueryClient } from "react-query";

const MAX_RETRY = 0;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      suspense: true,
      useErrorBoundary: true,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error.status === 404) return false;
        // `failureCount` start from `0`
        else if (failureCount < MAX_RETRY + 1) return true;
        else return false;
      },
    },
  },
});
